import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ContentModal({
  message,
  title,
  content,
  open,
  actions,
  handleClose,
  maxWidth,
}) {
  const handleBackdropClick = (event, reason) => {
    if (reason === "backdropClick") {
      // || reason === "escapeKeyDown") {
      return;
    }
    handleClose();
  };
  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth={maxWidth}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleBackdropClick}
      >
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
          {message && <DialogContentText>{message}</DialogContentText>}
          {content}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {actions}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
